export const checkIfChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
